export default "__VITE_ASSET__BmQX$4jh__"